import type { EndpointDef } from '@skynet/data-helpers';

/**
 * Central endpoint definitions — single source of truth for the Trading Bots API.
 *
 * This file drives:
 * - **Enhanced API**: computed endpoint keys in `enhanceEndpoints`
 * - **Hook re-exports**: clean name → generated name mapping
 * - **MSW mock factories**: HTTP method + URL path pattern
 *
 * When the OpenAPI spec changes and codegen regenerates, update this
 * file to keep everything in sync.
 */
export const TRADING_BOTS_API_ENDPOINTS = {
  listTradingBots: {
    generated: 'tradingBotsAdminControllerListTradingBotsV1',
    method: 'get',
    path: '/api/v1/admin/trading-bots',
  },
} as const satisfies Record<string, EndpointDef>;

export type TradingBotsEndpointName = keyof typeof TRADING_BOTS_API_ENDPOINTS;
